import { DEFAULT_USER_DISABLE_MEETINGS_DELETE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useDefaultUserDisableMeetingsDelete() {
  return useIsFeatureEnabled(DEFAULT_USER_DISABLE_MEETINGS_DELETE);
}
